import { merge, Stack, StackItem } from '@fluentui/react';
import React, { useMemo } from 'react';
import jAccueil from '../../../assets/icons/json/accueil-red.json';
import jActus from '../../../assets/icons/json/actus-red.json';
import jCadeau from '../../../assets/icons/json/cadeau-red.json';
import jChercher from '../../../assets/icons/json/chercher-red.json';
import jDocuments from '../../../assets/icons/json/document-red.json';
import jEuro from '../../../assets/icons/json/euro-red.json';
import jMessages from '../../../assets/icons/json/messages-red.json';
import offRedIcon from '../../../assets/icons/svg/offRed.svg';
import { AccessType, useAuth, useAuthManager } from '../../../contexts/authContext';
import { useDocuments } from '../../../contexts/documentContext';
import { useMessages } from '../../../contexts/messageContext';
import { ResponsiveSize, useResponsiveSize } from '../../../contexts/responsiveContext';
import MenuItem from './MenuItem';
import UserMenuDropdown from './UserMenuDropdown';

const Menu = (props) => {

    // PROPS
    const {
        isOpen = false,
        onChange = () => null
    } = props;

    // CONTEXTS
    const { accessType } = useAuth();
    const { disconnect } = useAuthManager();
    const { unreadBenefits, unreadDocuments } = useDocuments();
    const { responsiveSize } = useResponsiveSize();
    const { totalUnreadMessages } = useMessages();

    // MEMOS
    const _styles = useMemo(
        () => {
            let styles = {
                outer: {
                    root: {
                        background: "white",
                        borderBottom: "1px solid #C4C4C4",
                        display: isOpen ? "flex" : "none",
                        height: document.getElementById('root').scrollHeight - 68,
                        left: 0,
                        position: "absolute",
                        right: 0,
                        top: 68,
                        zIndex: 2
                    }
                },
                disconnectButton: { root: { color: "red" } }
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(styles, {
                    outer: {
                        root: {
                            borderBottom: "none",
                            borderRight: "1px solid #C4C4C4",
                            bottom: 52,
                            display: "flex",
                            gap: 67,
                            height: "unset",
                            maxWidth: 240,
                            minWidth: 240,
                            paddingLeft: 48,
                            paddingRight: 14,
                            paddingTop: 43,
                            position: "fixed",
                            top: 84,
                            selectors: {
                                "@media(max-height:900px)": {
                                    gap: "unset",
                                    justifyContent: "space-around",
                                    paddingTop: "unset",
                                }
                            }
                        }
                    },
                    overlay: {
                        root: {
                            background: "white",
                            inset: 0,
                            opacity: 0.7,
                            position: "absolute",
                            zIndex: 1
                        }
                    }
                });

            return styles;
        },
        [isOpen, responsiveSize]
    );

    const _items = useMemo(() => [
        { id: "accueil", label: "Accueil", path: "/", json: jAccueil },
        { id: "actualites", label: "Actualités", path: "/actualites", json: jActus },
        { id: "monLogement", label: "Mon logement", path: "/monlogement", json: jChercher },
        { id: "messages", label: "Messages", path: "/messages", json: jMessages, badgeId: "txtTotalUnreadMessages", badgeLabel: totalUnreadMessages },
        { id: "documents", label: "Documents", path: "/documents", json: jDocuments, badgeId: "txtUnreadDocuments", badgeLabel: unreadDocuments },
        { id: "appelsDeFonds", label: "Appels de fonds", path: "/appelsdefonds", json: jEuro },
        { id: "avantagesEtServices", label: "Avantages\r\n& Services", path: "/avantagesetservices", json: jCadeau, badgeLabel: unreadBenefits },
    ], [totalUnreadMessages, unreadBenefits, unreadDocuments]);

    // RENDER
    return <Stack styles={_styles.outer}>

        {responsiveSize === ResponsiveSize.small && <UserMenuDropdown />}

        {_items.map((pictogramme, index) => {
            const { badgeId, badgeLabel, id, json, label, path } = pictogramme;
            return <MenuItem
                badgeId={badgeId}
                badgeLabel={badgeLabel}
                id={id}
                json={json}
                key={id}
                label={label}
                onClick={onChange}
                path={path}
            />;
        })}

        {accessType <= AccessType.restricted && <StackItem styles={_styles.overlay}> </StackItem>}

        {responsiveSize === ResponsiveSize.small && <MenuItem
            customStyles={{ label: { root: { color: "#8A8A8A", fontWeight: 400 } } }}
            label="DÉCONNEXION"
            onClick={disconnect}
            src={offRedIcon}
        />}

    </Stack>

};

export default Menu;